'use client';

/**
 * Global Error Boundary — catches errors in root layout and all routes.
 * Uses plain HTML/CSS (no Chakra) because the UI provider may have failed.
 */
export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <html lang="en">
      <body
        style={{
          margin: 0,
          fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          backgroundColor: '#f7fafc',
          padding: '24px',
        }}
      >
        <div style={{ maxWidth: '500px', textAlign: 'center' }}>
          <h1 style={{ fontSize: '24px', marginBottom: '8px', color: '#1a202c' }}>
            Something went wrong
          </h1>
          <p
            style={{
              fontSize: '14px',
              color: '#718096',
              marginBottom: '16px',
              wordBreak: 'break-word',
            }}
          >
            {error.message || 'An unexpected error occurred.'}
          </p>
          {error.digest && (
            <p style={{ fontSize: '12px', color: '#a0aec0', marginBottom: '16px' }}>
              Error ID: {error.digest}
            </p>
          )}
          <div style={{ display: 'flex', gap: '12px', justifyContent: 'center' }}>
            <button
              onClick={() => (window.location.href = '/')}
              style={{
                padding: '8px 16px',
                border: '1px solid #e2e8f0',
                borderRadius: '6px',
                backgroundColor: 'white',
                cursor: 'pointer',
                fontSize: '14px',
              }}
            >
              Home
            </button>
            <button
              onClick={reset}
              style={{
                padding: '8px 16px',
                border: 'none',
                borderRadius: '6px',
                backgroundColor: '#3182ce',
                color: 'white',
                cursor: 'pointer',
                fontSize: '14px',
              }}
            >
              Try Again
            </button>
          </div>
        </div>
      </body>
    </html>
  );
}
